module.exports = __webpack_public_path__ + "img/画板 1 拷贝 6.f56bc422.jpg";